import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Upload, FileText } from 'lucide-react';
import { motion } from 'framer-motion';

interface BatchUploadButtonProps {
  variant?: 'primary' | 'secondary';
  className?: string;
}

export default function BatchUploadButton({ variant = 'secondary', className = '' }: BatchUploadButtonProps) {
  const navigate = useNavigate();

  const baseClasses = "inline-flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variantClasses = {
    primary: "bg-brand-600 text-white hover:bg-brand-700 focus:ring-brand-500",
    secondary: "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 focus:ring-gray-500"
  };

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => navigate('/batch-upload')}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      title="Upload multiple quotes from files"
    >
      <Upload className="h-4 w-4" />
      <span className="hidden sm:inline">Batch Upload</span>
      <span className="sm:hidden">Upload</span>
    </motion.button>
  );
}